import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectServices = state => state.get('services', initialState);

const makeSelectServices = () =>
  createSelector(selectServices, servicesState =>
    servicesState.getIn(['services']),
  );

const makeSelectError = () =>
  createSelector(selectServices, servicesState => servicesState.get('error'));

const makeSelectLoading = () =>
  createSelector(selectServices, servicesState => servicesState.get('loading'));

const makeSelectSelectedServices = () =>
  createSelector(selectServices, servicesState =>
    servicesState.get('selected'),
  );

const makeSelectProductServices = () =>
  createSelector(selectServices, servicesState =>
    servicesState.get('productServices'),
  );

export {
  selectServices,
  makeSelectServices,
  makeSelectError,
  makeSelectLoading,
  makeSelectSelectedServices,
  makeSelectProductServices,
};
